export const Types = {
  GET_AGENDAMENTOS: "agendamentos/GET_AGENDAMENTOS",
  GET_AGENDAMENTOS_SUCCESS: "agendamentos/GET_AGENDAMENTOS_SUCCESS",
  ADD_AGENDAMENTOS: "agendamentos/ADD_AGENDAMENTOS",
  GET_AGENDAMENTO: "agendamentos/GET_AGENDAMENTO",
  GET_AGENDAMENTO_SUCCESS: "agendamentos/GET_AGENDAMENTO_SUCCESS",
  EDIT_AGENDAMENTOS: "agendamentos/EDIT_AGENDAMENTOS",
  EXCLUIR_AGENDAMENTOS: "agendamentos/EXCLUIR_AGENDAMENTOS"
};

const INITIAL_STATE = {
  agendamentos: [],
  item: {}
};

export default function agendamentos(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_AGENDAMENTOS:
      return { ...state };
    case Types.GET_AGENDAMENTOS_SUCCESS:
      return {
        ...state,
        agendamentos: action.payload.agendamentos
      };
    case Types.GET_AGENDAMENTO:
      return { ...state };
    case Types.GET_AGENDAMENTO_SUCCESS:
      return {
        ...state,
        item: action.payload.data
      };
    default:
      return state;
  }
}

export const Creators = {
  getAgendamentos: () => ({
    type: Types.GET_AGENDAMENTOS
  }),
  getAgendamentosSuccess: agendamentos => ({
    type: Types.GET_AGENDAMENTOS_SUCCESS,
    payload: { agendamentos }
  }),
  addAgendamentos: data => ({
    type: Types.ADD_AGENDAMENTOS,
    payload: data
  }),
  getAgendamento: id => ({
    type: Types.GET_AGENDAMENTO,
    payload: { id }
  }),
  getAgendamentoSuccess: data => ({
    type: Types.GET_AGENDAMENTO_SUCCESS,
    payload: { data }
  }),
  editAgendamentos: data => ({
    type: Types.EDIT_AGENDAMENTOS,
    payload: data
  }),
  excluirAgendamentos: () => ({
    type: Types.EXCLUIR_AGENDAMENTOS
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/agendamentos.js